export const SET_LOADING = 'src/store/userRole/SET_LOADING'
export const SET_USER_ROLE = 'src/store/userRole/SET_USER_ROLE'
export const SET_USER_ROLE_RESPONSE = 'src/store/userRole/SET_USER_ROLE_RESPONSE'
